import { EventDispatcher } from "three";
import { SOCKET_EVENTS } from "./Socket";
import io from 'socket.io-client';

export let userProperties = {};

export default class RoomSocket extends EventDispatcher {
  constructor({ model }) {
    super();
    this.model = model;
    this.socket;
    this._currentUserData = {};
  }
  _send(payload, eventName = 'message') {
    this.socket && this.socket.emit(eventName, payload);
  }

  init(roomConfig) {
    let socket;
    roomConfig.currentSceneName = "rooms";
    roomConfig.currentSceneId = 0;
    roomConfig.creatorUserIdOfWorld = 0;
    roomConfig.url = window.location.href;

    socket = io(roomConfig['socketUrl'], {
      transports: ['websocket', 'polling'],
      query: roomConfig,
    });
    this.socket = socket;


    socket.on('connect', () => {
      this.model.info('success', "Connected to online services");
      setTimeout(() => {
        this.model.info('success', "Loading online users...");
      }, 500)
      userProperties.socketId = socket.id;
    });

    socket.on('initialized', () => {
      socket.initialized = true
      this.model.dispatchEvent({ type: SOCKET_EVENTS.SOCKET_CONNECT_SUCCESS });
      this.initialised = true;
    })

    socket.on('disconnect', (reason) => {
      this.model.dispatchEvent({ type: SOCKET_EVENTS.DISCONNECT });
      // this.model.alert('success', "Online services error");
      // this.model.info('success', "Reconnecting to online services");
      console.log('disconnect', reason);
      if (reason === 'io server disconnect') { // the disconnection was initiated by the server, you need to reconnect manually
        setTimeout(() => {
          socket.connect();
        }, 5000);
      }
    });

    socket.on('message', (payload) => {
      try {
        switch (payload.eventName) {
          case 'currentUsers':
            console.log('currentUsers', payload);
            userHistory = payload.data;
            filterSocketItems(userHistory)
            this._currentUserData = payload.data || {};
            for (let [key, value] of Object.entries(this._currentUserData)) {
              if (value.userScreenShareOn) {
                var obj = {};
                obj[value.objId] = value.userId;
                this._currentUserData.occupiedScreens = obj;
              }
            }
            // this.dispatchEvent({ type: SOCKET_EVENTS.USER_DATA_CHANGED, data: this._currentUserData });
            this.dispatchEvent({ type: SOCKET_EVENTS.INIT_USERS });
            break;
          case 'sessionConnected':
            userHistory[payload.data.userId] = payload.data;
            this._currentUserData[payload.data.userId] = payload.data;
            break;
          case 'sessionDisconnected':
            if (this._currentUserData[payload.data.userId]) {
              delete this._currentUserData[payload.data.userId];
            }
            break;
          case 'getUsersInfo':
            this.onlineFriends = payload.users;
            this.dispatchEvent({ type: SOCKET_EVENTS.ONLINE_FRIENDS_LOADED });
            break;
        }

      } catch (exception) {
        console.error('VRSocketManager._handleMessage()', exception, payload.eventName, payload);
      }
    })

    socket.on('me', (id) => () => {
      console.log("MEEEE", id)
      this.me = id;
    });
  }
  requestFriendsInfo = (friendsIds) => {
    this._send({
      eventName: 'getUsersInfo',
      userIds: friendsIds,
      senderId: userProperties.userId,
    });
    // this.dispatchEvent({ type: SOCKET_EVENTS.FRIENDS_LIST_LOADED });
  }
}
